import { ADD_RESPONSES, FETCHING_RESPONSES, FETCHED_RESPONSES } from '../constants';

interface ResponsesState {
  list: Record<string, any[]>;
  fetching: boolean;
  /** project_id -> timestamp (serializable); used to skip refetch when already loaded */
  fetched: Record<string, number>;
}

const initialState: ResponsesState = {
  list: {},
  fetching: false,
  fetched: {},
};

export default function responsesReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any }
): ResponsesState {
  switch (type) {
    case ADD_RESPONSES:
      return {
        ...state,
        list: { ...state.list, [payload.project_id]: payload.list },
      };
    case FETCHING_RESPONSES:
      return { ...state, fetching: payload };
    case FETCHED_RESPONSES:
      return { ...state, fetched: { ...state.fetched, [payload.project_id]: Date.now() } };
    default:
      return state;
  }
}
